import useSWR from 'swr';
import { fetchCommendaAiReferencePreview } from './api';
import type {
  CommendaAiReferencePreview,
  CommendaAiReferenceType,
} from './types';

// A record's metadata does not move while a chat is open, and each miss costs an authorization
// check plus the reads behind the card.
const REFERENCE_PREVIEW_TTL_MS = 5 * 60 * 1000;

export function useChatReferencePreview(
  type: CommendaAiReferenceType,
  referenceId: string,
  isEnabled: boolean
): {
  preview: CommendaAiReferencePreview | undefined;
  isLoading: boolean;
  error: Error | undefined;
} {
  const { data, error, isLoading } = useSWR(
    isEnabled
      ? (['commenda-ai/reference-preview', type, referenceId] as const)
      : null,
    () => fetchCommendaAiReferencePreview(type, referenceId),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      dedupingInterval: REFERENCE_PREVIEW_TTL_MS,
    }
  );

  return {
    preview: data,
    isLoading: isEnabled && isLoading,
    error,
  };
}
